
import Vue from 'vue';
import { ROUTER } from '@/router/constants';
import { BoardsV2AccessMixin } from '@/mixins';
import { rememberBoardsVersion } from '@/utils/boardsVersion';
import RunnitBoardsManagement
	from '@/views/Runnits/pages/RunnitBoardsPage/RunnitBoardsDashboard/RunnitBoardsManagement.vue';
import RunnitBoardOnboardingBanner
	from '@/views/Runnits/pages/RunnitBoardsPage/RunnitBoardsDashboard/RunnitBoardOnboardingBanner.vue';
import RunnitBoardOnboardingDialog
	from '@/views/Runnits/pages/RunnitBoardsPage/RunnitBoardsDashboard/RunnitBoardOnboadingDialog.vue';
import BoardsV2IntroBanner from '@/views/Runnits/pages/RunnitBoardsPage/components/BoardsV2IntroBanner.vue';

export default Vue.extend({
	name: 'RunnitBoardsDashboard',
	mixins: [
		BoardsV2AccessMixin,
	],
	data () {
		return {
			showOnboardingDialog: false,
		};
	},
	computed: {
		showBoardsV2 (): boolean {
			return this.boardsV2Access === 'on';
		},
	},
	methods: {
		openBoardsV2 () {
			rememberBoardsVersion('v2');
			this.routerPush(this.$route, this.$router, { name: ROUTER.RUNNIT_BOARDS_V2_PAGE });
		},
	},
	components: {
		BoardsV2IntroBanner,
		RunnitBoardsManagement,
		RunnitBoardOnboardingBanner,
		RunnitBoardOnboardingDialog,
	},
});
